import { Component } from '@angular/core';

@Component({
  selector: 'ocado-system-maintenance',
  standalone: true,
  imports: [],
  templateUrl: './system-maintenance.component.html',
  styleUrl: './system-maintenance.component.scss'
})
export class SystemMaintenanceComponent {

}
